import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  className?: string;
  onClick?: () => void;
}
export function CtaButton({
  text,
  className = '',
  onClick
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(0, 255, 102, 0.4)', '0px 0px 20px 10px rgba(0, 255, 102, 0.4)', '0px 0px 0px 0px rgba(0, 255, 102, 0.4)']
  }} transition={{
    duration: 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} className={`group relative inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-xl md:text-2xl font-extrabold text-black bg-[#00FF66] rounded-full overflow-hidden transition-all hover:bg-[#00cc52] ${className}`} data-id="element-45">
      <span className="relative z-10 flex items-center gap-2" data-id="element-46">
        {text}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-47" />
      </span>
      {/* Glossy overlay effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" data-id="element-48" />
    </motion.button>;
}